export default __webpack_public_path__ + "media/images/react_icons/brush_alt-816fed62ab5d8472ddbfa0f58af82a7a.svg";